<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Revisión de Factura
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="frm" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="8" offset-md="2">
                                    <span style="color: black !important;">Reporte(s):</span>
                                    <v-card>
                                        <v-data-table :headers="header"
                                                      hide-default-footer
                                                      :items="datos">
                                            <template v-slot:body.append>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Total:</td>
                                                    <td>
                                                        {{total}}
                                                    </td>
                                                    <td colspan="4"></td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8" offset-md="2">
                                    <v-btn @click="Factura()"
                                           color="primary">
                                        Factura
                                        <v-icon dark
                                                right>
                                            mdi-text-box-search-outline
                                        </v-icon>
                                    </v-btn>
                                    <v-overlay :value="loader">
                                        <v-progress-circular indeterminate
                                                             size="64"></v-progress-circular>
                                    </v-overlay>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col v-if="FacturaDatos.length > 0" md="6" cols="12">
                                    <v-row justify="center">
                                        <v-col cols="12" md="6" offset-md="3">
                                            <v-alert type="success" v-if="FacturaDatos[0].rfc">
                                                RFC válido
                                            </v-alert>
                                        </v-col>
                                        <v-col cols="12" md="6" offset-md="3" class="mt-n8">
                                            <v-alert type="success" v-if="FacturaDatos[0].regimen">
                                                Régimen fiscal validado
                                            </v-alert>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="12" md="6" offset-md="3">
                                            <v-alert type="error" v-if="FacturaDatos[0].rfc == false">
                                                RFC inválido
                                            </v-alert>
                                        </v-col>
                                        <v-col cols="12" md="6" offset-md="3" class="mt-n8">
                                            <v-alert type="error" v-if="FacturaDatos[0].regimen == false">
                                                Régimen fiscal invalidado
                                            </v-alert>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col md="6" cols="12" v-if="sinfac == true">
                                    <v-row>
                                        <v-col cols="12" md="6" offset-md="3" class="mt-n8">
                                            <v-alert type="error">
                                                No tiene factura asignada
                                            </v-alert>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col md="6" v-if="FacturaDatos.length > 0" cols="12">
                                    <v-row v-if="regimenfiscal == 612">
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>Subtotal</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{fact[0].subtotal}}
                                                <v-icon v-if="subtotalval" large
                                                        color="green darken-2">
                                                    mdi-check-bold
                                                </v-icon>
                                                <v-icon v-if="!subtotalval" large
                                                        color="error darken-2">
                                                    mdi-close-thick
                                                </v-icon>
                                            </label>
                                        </v-col>
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>IVA</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{fact[0].iva}}
                                                <v-icon v-if="ivaval" large
                                                        color="green darken-2">
                                                    mdi-check-bold
                                                </v-icon>
                                                <v-icon v-if="!ivaval" large
                                                        color="error darken-2">
                                                    mdi-close-thick
                                                </v-icon>
                                            </label>
                                        </v-col>
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>Retención IVA</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{FacturaDatos[0].riva}}
                                                <v-icon v-if="ivarval" large
                                                        color="green darken-2">
                                                    mdi-check-bold
                                                </v-icon>
                                                <v-icon v-if="!ivarval" large
                                                        color="error darken-2">
                                                    mdi-close-thick
                                                </v-icon>
                                            </label>
                                        </v-col>
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>Retención ISR</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{FacturaDatos[0].isr}}
                                                <v-icon v-if="isrval" large
                                                        color="green darken-2">
                                                    mdi-check-bold
                                                </v-icon>
                                                <v-icon v-if="!isrval" large
                                                        color="error darken-2">
                                                    mdi-close-thick
                                                </v-icon>
                                            </label>
                                        </v-col>
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>Total</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{FacturaDatos[0].Total}}
                                            </label>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="regimenfiscal == 601">
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>Subtotal</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{fact[0].subtotal}}
                                                <v-icon v-if="subtotalval" large
                                                        color="green darken-2">
                                                    mdi-check-bold
                                                </v-icon>
                                                <v-icon v-if="!subtotalval" large
                                                        color="error darken-2">
                                                    mdi-close-thick
                                                </v-icon>
                                            </label>
                                        </v-col>
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>IVA</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{fact[0].iva}}
                                                <v-icon v-if="ivaval" large
                                                        color="green darken-2">
                                                    mdi-check-bold
                                                </v-icon>
                                                <v-icon v-if="!ivaval" large
                                                        color="error darken-2">
                                                    mdi-close-thick
                                                </v-icon>
                                            </label>
                                        </v-col>
                                        <v-col cols="12" md="4" offset-md="4">
                                            <span>Total</span><br />
                                            <label class="typo__label" style="color: black; text-align: center;">
                                                {{FacturaDatos[0].Total}}
                                            </label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8" offset-md="2" justify="center">
                                    <span style="color: black;">UUID</span>
                                    <v-text-field v-model="uuid"
                                                  readonly
                                                  outlined
                                                  style="font-family: Consolas">
                                        <template v-slot:append-outer>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn color="blue-grey"
                                                           small
                                                           icon
                                                           v-bind="attrs"
                                                           v-on="on"
                                                           @click="Copiar">
                                                        <v-icon>
                                                            mdi-content-copy
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Copiar</span>
                                            </v-tooltip>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2" justify="center">
                                    <span style="color: black;">
                                        ¿La factura es válida ante el SAT?:
                                        <a href="https://verificacfdi.facturaelectronica.sat.gob.mx/" target="_blank">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon color="blue-grey" v-bind="attrs"
                                                           fab
                                                           dark
                                                           v-on="on">
                                                        <v-icon>
                                                            mdi-alpha-s-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Verificar en el SAT</span>
                                            </v-tooltip>
                                        </a>
                                    </span>
                                    <v-radio-group v-model="vigencia" row :rules="[v => !!v || 'Opción requerida']" @change="Valida()">
                                        <v-radio label="Si" style="color: black; text-align: center;"
                                                 value="1"></v-radio>
                                        <v-radio label="No" style="color: black; text-align: center;"
                                                 value="2"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2" justify="center" v-if="validarconfirma">
                                    <span style="color: black;">Firma Electrónica:</span>
                                    <v-text-field v-model="usfirma" outlined style="-webkit-text-security: disc;">
                                    </v-text-field>
                                    <span id="errorfirma" class="mt-n16" style="color: red"></span>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2">
                                    <span style="color: black;">Fecha:</span>
                                    <v-menu ref="menu1"
                                            v-model="menu1"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dateFormatted"
                                                          outlined
                                                          readonly
                                                          v-bind="attrs"
                                                          @blur="date = parseDate(dateFormatted)"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date"
                                                       locale="es-mx"
                                                       :max="maxfecha"
                                                       :min="mindate"
                                                       @input="menu1 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2">
                                    <span style="color: black;">Enviar reporte a trámite  de pago:</span>
                                    <v-radio-group v-model="rbrespuesta" row :rules="[v => !!v || 'Opción requerida']">
                                        <v-radio label="Si" style="color: black; text-align: center;"
                                                 value="1"></v-radio>
                                        <v-radio label="No" style="color: black; text-align: center;"
                                                 value="2"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2" v-if="rbrespuesta == 1">
                                    <label class="typo__label" style="color: black;">Centro de Costos:</label>
                                    <div>
                                        <multiselect placeholder="Seleccione un valor" :options="cc" v-model="mcc"
                                                     label="ccsubcentro" track-by="ccclave"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors">
                                        </multiselect>
                                        <span id="valcc" style="display: none">Selección requerida</span>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2" v-if="rbrespuesta == 1">
                                    <span style="color: black;">Concepto:</span>
                                    <v-text-field outlined :rules="[v => !!v || 'Campo requerido']"
                                                  v-model="concepto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="8" offset-md="2">
                                    <span style="color: black;">Observaciones:</span>
                                    <v-textarea :counter="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-btn class="ma-2"
                                           @click="Guardar()"
                                           color="primary"
                                           :disabled="habilitar">
                                        Guardar
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    <v-btn class="ma-2" @click="Limpiar()">
                                        Limpiar
                                    </v-btn>
                                    <v-btn class="ma-2" color="error" @click="Regresar()">
                                        Regresar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="verarchi"
                  scrollable
                  persistent
                  max-width="70%">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Factura</span>
                </v-card-title>
                <v-card-text>
                    <v-progress-linear :active="loading"
                                       :indeterminate="loading"
                                       color="primary"
                                       class="mb-0"></v-progress-linear>

                    <div class="py-1 text-center">
                        
                        <v-row justify="center" style="margin-top: 2%;">
                            <v-col cols="12" md="12">
                                <div id="ver" style="border-radius: 10%;" class="videoWrapper">
                                    <iframe id="doctos" embeddeb="true"></iframe>
                                </div>
                            </v-col>
                           
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn dark
                           color="error"
                           @click="CerrarVisor()">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import servicio from '@/services/TramitePago/TramitePago.Service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            verarchi: false,
            loading: true,
            valid: true,
            maxfecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            datos: [],
            comentarios: '',
            header: [
                { text: 'Reporte', value: 'nrreporte', class: "text title" },
                { text: 'Concepto', value: 'cpdesc', class: "text title" },
                { text: 'Contrarecibo', value: 'tpcontrarecibo', class: "text title" },
                { text: 'Abogado', value: 'prnombre', class: "text title" },
                { text: 'Cliente', value: 'clnombre', class: "text title" },
                { text: 'Monto', value: 'tpmonto', class: 'text title' },
                { text: 'Fecha Reporte', value: 'svfhreporte', sortable: false },
            ],
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length <= 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            mindate: '',
            rbrespuesta: 0,
            regimenfiscal: 0,
            total: 0.00,
            FacturaDatos: [],
            fact: [],
            subtotalval: '',
            ivaval: '',
            ivarval: '',
            isrval: '',
            total: '',
            loader: true,
            uuid: '',
            vigencia: 0,
            validarconfirma: false,
            usfirma: '',
            validacionfactura: [],
            cc: [],
            mcc: [],
            concepto: '',
            colors: '',
            sinfac: false,
            habilitar: false,
            validafirma: false,
        }),
        props: ['contrarecibo', 'prclave'],
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
            'rbrespuesta': function () {
                if (this.rbrespuesta == 2 && this.sinfac == true)
                    this.habilitar = false;
                else if (this.rbrespuesta == 1 && this.sinfac == true)
                    this.habilitar = true;
            },
            'usfirma': function () {
                this.validafirma = false;
                this.ValidarFirma();
            },
        },
        methods: {
            ValidarFirma() {
                let span = document.getElementById('errorfirma');
                if (this.usfirma.length == 0)
                    span.textContent = 'Campo requerido';
                else if (this.usfirma.length < 8 || this.usfirma.length > 16)
                    span.textContent = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
                else {
                    span.textContent = '';
                    this.validafirma = true;
                }
            },
            ObtenerCentroCosto() {
                servicio.CentroCosto(this).then(data => {
                    this.cc = data;
                });
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            ObtenerReporteContrarecibo() {
                let formdata = new FormData();
                formdata.append("contrarecibo", this.contrarecibo);
                servicio.ObtenerReporteContrarecibo(this, formdata).then(data => {
                    this.datos = data;
                    let dato = 0;
                    for (let x in this.datos) {
                        dato += parseFloat(this.datos[x].tpmonto.replace(/([^0-9\.\-])/g, ''));//Ahora que es un objeto javascript, tiene propiedades

                    }
                    this.total = dato.toString();
                    this.total = MetodosGenerales.regresarValorMoneda(this.total, '$');

                    let mayor = Math.max(...this.datos.map(x => parseInt(x.Row)));
                    let dats = this.datos.filter(x => x.Row == mayor);
                    this.mindate = this.parseDate(dats[0].xpfecha);
                });
            },
            Regresar() {
                this.$router.push({ name: `ListadoContrarecibo` });
            },
            Guardar() {
                let formdatos = new FormData();
                formdatos.append("usfirma", this.usfirma);
                formdatos.append("reporte", 0);
                formdatos.append("indice", 0);
                this.comentarios = this.comentarios.trim();
                this.comentarios = this.comentarios.replace(/\s*$/, "");
                this.ValidarFirma();
                if (this.$refs.frm.validate() && this.comentarios.length >= 12 && this.validafirma == true) {
                    servicio.ValidaFirmaElectronica(this, formdatos).then(data => {
                        if (data == true || this.validarconfirma == false) {
                            let formdata = new FormData();
                            formdata.append("datos", JSON.stringify(this.datos));
                            formdata.append("validacion", JSON.stringify(this.validacionfactura));
                            formdata.append("resp", this.rbrespuesta);
                            formdata.append("fecha", this.date);
                            formdata.append("obs", this.comentarios);
                            formdata.append("prclave", this.prclave);
                            formdata.append("concepto", this.concepto);
                            formdata.append("ccclave", this.mcc.ccclave);
                            formdata.append("contrarecibo", this.contrarecibo);
                            formdata.append("monto", parseFloat(this.total.replace(/([^0-9\.\-])/g, '')));
                            this.$swal({
                                title: "Guardando, espere un momento...",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                            this.$swal.showLoading();
                            if (this.rbrespuesta == 1) {
                                servicio.ValidarPagoFactura(this, formdata).then(data => {
                                    if (data[0].success == "true") {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito",
                                            text: "Se ha autorizado el pago",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            showConfirmButton: true,
                                            timer: 2000,
                                            confirmButtonText: "Ok!",
                                        }).then(() => {
                                            this.$router.push({ name: `ListadoContrarecibo` });
                                        });
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "error",
                                            title: "Error",
                                            text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            showConfirmButton: true,
                                            confirmButtonText: "Ok!",
                                        });
                                    }
                                });
                            }
                            else {
                                servicio.ValidarPagoFactura(this, formdata).then(data => {
                                    if (data[0].success == "true") {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito",
                                            text: "Se ha rechazado el pago",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            showConfirmButton: true,
                                            timer: 2000,
                                            confirmButtonText: "Ok!",
                                        }).then(() => {
                                            this.$router.push({ name: `ListadoContrarecibo` });
                                        });
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "error",
                                            title: "Error",
                                            text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            showConfirmButton: true,
                                            confirmButtonText: "Ok!",
                                        });
                                    }
                                });
                            }
                        }
                        else {
                            this.usfirma = '';
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error",
                                text: "Firma electrónica incorrecta",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Ok!",
                            });
                        }

                    });


                }
            },
            Factura() {
                let formdata = new FormData();
                formdata.append("contrarecibo", this.contrarecibo);
                formdata.append("prclave", this.prclave);

                servicio.ObtenerFacturaArchivo(this, formdata).then(data => {
                    console.log(data);
                    this.loading = false;
                    if (data.error == false) {
                        var iframe2 = document.getElementById("doctos");
                        iframe2.setAttribute("src", data.watch);
                        iframe2.style.borderRadius = "1%";
                        iframe2.style.border = "solid gray 1px";
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: data.msg,
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }
                });
                this.verarchi = true;
            },
            ValidarFactura() {

                let formdata = new FormData();
                formdata.append("contrarecibo", this.contrarecibo);
                formdata.append("prclave", this.prclave);
                servicio.ValidarFactura(this, formdata).then(data => {
                    if (data[0].Error == "True") {
                        this.fact = data;
                        this.uuid = data[0].UUID;
                        this.regimenfiscal = data[0].regimenfiscal;
                        let formd = new FormData();
                        formd.append("prclave", this.prclave);
                        formd.append("rfc", this.fact[0].RFC);
                        formd.append("regimen", this.fact[0].regimenfiscal);
                        formd.append("facid", this.contrarecibo);
                        servicio.ObtenerDatosProveedor(this, formd).then(data => {
                            this.FacturaDatos = data;

                            if (this.fact[0].regimenfiscal != "626") {
                                if (this.FacturaDatos[0].subtotal.replace(/([^0-9\.\-])/g, '') == this.fact[0].subtotal)
                                    this.subtotalval = true;
                                else
                                    this.subtotalval = false;
                                if (this.FacturaDatos[0].iva.replace(/([^0-9\.\-])/g, '') == this.fact[0].iva)
                                    this.ivaval = true;
                                else
                                    this.ivaval = false;
                                if (this.FacturaDatos[0].isr.replace(/([^0-9\.\-])/g, '') == this.fact[0].isrr)
                                    this.isrval = true;
                                else
                                    this.isrval = false;
                                if (this.FacturaDatos[0].riva.replace(/([^0-9\.\-])/g, '') == this.fact[0].ivar)
                                    this.ivarval = true;
                                else
                                    this.ivarval = false;
                            }
                            if (this.subtotalval == false || this.ivaval == false || this.isrval == false || this.ivarval == false)
                                this.validarconfirma = true;
                            this.loader = false;
                            
                            this.validacionfactura = {
                                "prclave": this.prclave,
                                "contrarecibo": this.contrarecibo,
                                "regimenfiscal": this.fact[0].regimenfiscal,
                                "rfc": this.FacturaDatos[0].RFC,
                                "subtotal": this.subtotalval,
                                "iva": this.ivaval,
                                "isr": this.isrval,
                                "ivar": this.ivarval,
                                "facturavalida": this.vigencia
                            };

                            
                        });
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: data[0].msg,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        this.loader = false;
                        this.sinfac = true;
                        this.habilitar = true;
                    }
                });
            },
            CerrarVisor() {
                this.verarchi = false;
            },
            Copiar() {
                var copyTextarea = document.createElement("textarea");
                copyTextarea.style.position = "fixed";
                copyTextarea.style.opacity = "0";
                copyTextarea.textContent = this.uuid;

                document.body.appendChild(copyTextarea);
                copyTextarea.select();
                document.execCommand("copy");
                document.body.removeChild(copyTextarea);
                this.$swal({
                    position: "center",
                    icon: "success",
                    title: "Correcto",
                    text: "El UUID se copió en el portapapeles, correctamente",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar",
                });
            },
            Valida() {
                if (this.vigencia == 2)
                    this.validarconfirma = true;
                else
                    this.validarconfirma = true;
            },
            ObtenerCCProveedor() {
                let formdata = new FormData();
                formdata.append("prclave", this.prclave);
                servicio.ObtenerCCProveedor(this, formdata).then(data => {
                    this.mcc = data;
                });
            },
            Limpiar() {
                this.comentarios = '';
                this.rbrespuesta = 0;
                this.vigencia = 0;
                this.concepto = '';
                this.mcc = '';
                this.usfirma = '';
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            },
        },
        mounted() {
            this.ObtenerCentroCosto();
            if (this.contrarecibo != undefined) {
                this.ObtenerReporteContrarecibo();
                this.ValidarFactura();
            }
            else
                this.$router.push({ name: `ListadoContrarecibo` });
        }
    }
</script>
<style>
    .videoWrapper {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        padding-top: 25px;
        height: 0;
    }

        .videoWrapper iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
</style>


